/*
  Koral Boutique - tarjeta de producto: miniaturas, visor y elementos de conversion.

  Cuatro cosas aprendidas a golpes, no cambiar sin probar:
  1) NO tocar el position de .card__media .media. El tema lo mantiene en absolute
     para llenar la caja; forzarlo a relative lo colapsa y la tarjeta sale en blanco.
  2) La tira se ancla a .card__inner, no a .media: .media no siempre ocupa toda la
     caja cuando el medio es video, y la tira quedaba a media altura.
  3) Nada de requestAnimationFrame para mostrar el visor.
  4) La visibilidad del visor se fija por estilo en linea, no por transicion CSS ni
     por observadores. Hay equipos con el renderizador degradado donde no corren ni
     IntersectionObserver, ni MutationObserver, ni las transiciones: ahi el visor se
     quedaba en opacity:0 aunque estuviera montado y con la clase puesta.

  No toca el Liquid: lee el producto con /products/<handle>.js.
  Para excluir una seccion, agregale la clase koral-no-thumbs.
*/
(function () {
  if (window.__koralCard) return;
  window.__koralCard = true;

  var MAX = 3;
  var cache = {};

  var CSS = [
    '.koral-thumbs{position:absolute!important;left:50%!important;right:auto!important;top:auto!important;bottom:12px!important;transform:translateX(-50%)!important;z-index:4!important;display:flex!important;flex-direction:row!important;align-items:center!important;gap:8px!important;margin:0!important;padding:6px!important;width:auto!important;max-width:calc(100% - 20px);border-radius:12px;background:rgba(255,255,255,.6);backdrop-filter:blur(8px);-webkit-backdrop-filter:blur(8px);box-shadow:0 2px 10px rgba(30,42,58,.18);pointer-events:auto!important;opacity:1!important;visibility:visible!important}',
    '.koral-thumb{width:42px!important;height:54px!important;min-width:42px;border-radius:8px;overflow:hidden;border:2px solid #fff;box-shadow:0 1px 4px rgba(30,42,58,.25);cursor:zoom-in;background:#fff;flex:0 0 auto;padding:0!important;margin:0!important;line-height:0;display:block;transition:transform .16s ease,border-color .16s ease}',
    '.koral-thumb:hover{transform:translateY(-3px)}',
    '.koral-thumb img{width:100%!important;height:100%!important;object-fit:cover;display:block;border-radius:6px}',
    '.koral-thumb.is-on{border-color:#486090}',
    '.koral-swap{position:absolute!important;top:0;left:0;width:100%!important;height:100%!important;object-fit:cover;object-position:center;opacity:0;transition:opacity .18s ease;z-index:2;pointer-events:none}',
    '.koral-swap.is-on{opacity:1}',
    '.koral-badge{position:absolute!important;top:12px;left:12px;z-index:4;background:rgba(255,255,255,.85);backdrop-filter:blur(6px);-webkit-backdrop-filter:blur(6px);color:#1E2A3A;font-size:11px;line-height:1;letter-spacing:.02em;font-weight:600;padding:7px 10px;border-radius:20px;box-shadow:0 1px 4px rgba(30,42,58,.18);pointer-events:none}',
    '.card-wrapper{transition:transform .18s ease}',
    '.card-wrapper:hover{transform:translateY(-3px)}',
    '.koral-lb{position:fixed;inset:0;z-index:99999;background:rgba(16,22,32,.92);display:none;flex-direction:column;align-items:center;justify-content:center}',
    '.koral-lb.is-open{display:flex}',
    '.koral-lb__img{max-width:88vw;max-height:74vh;object-fit:contain;border-radius:6px;box-shadow:0 8px 40px rgba(0,0,0,.5)}',
    '.koral-lb__close{position:absolute;top:16px;right:18px;width:44px;height:44px;border-radius:50%;border:0;background:rgba(255,255,255,.16);color:#fff;font-size:26px;line-height:1;cursor:pointer;display:flex;align-items:center;justify-content:center}',
    '.koral-lb__close:hover{background:rgba(255,255,255,.3)}',
    '.koral-lb__nav{position:absolute;top:50%;transform:translateY(-50%);width:48px;height:48px;border-radius:50%;border:0;background:rgba(255,255,255,.16);color:#fff;font-size:24px;cursor:pointer;display:flex;align-items:center;justify-content:center}',
    '.koral-lb__nav:hover{background:rgba(255,255,255,.3)}',
    '.koral-lb__nav--prev{left:14px}.koral-lb__nav--next{right:14px}',
    '.koral-lb__strip{display:flex;gap:8px;margin-top:16px;padding:0 12px;max-width:92vw;overflow-x:auto}',
    '.koral-lb__t{width:46px;height:60px;border-radius:6px;overflow:hidden;border:2px solid transparent;background:none;padding:0;cursor:pointer;flex:0 0 auto;opacity:.55}',
    '.koral-lb__t.is-on{opacity:1;border-color:#fff}',
    '.koral-lb__t img{width:100%;height:100%;object-fit:cover;display:block}',
    '.koral-lb__cap{color:#fff;font-size:13px;margin-top:12px;opacity:.85;text-align:center;padding:0 16px}',
    'body.koral-lb-open{overflow:hidden}',
    '@media (max-width:749px){.koral-thumbs{bottom:8px!important;gap:6px!important;padding:5px!important}.koral-thumb{width:34px!important;height:44px!important;min-width:34px}.koral-badge{font-size:10px;padding:6px 9px;top:10px;left:10px}.koral-lb__nav{width:40px;height:40px}}'
  ].join('');

  function css() {
    if (document.getElementById('koral-card-css')) return;
    var s = document.createElement('style');
    s.id = 'koral-card-css';
    s.textContent = CSS;
    (document.head || document.documentElement).appendChild(s);
  }

  function sized(url, w) {
    return url.indexOf('?') > -1 ? url + '&width=' + w : url + '?width=' + w;
  }

  var lb = null, lbImgs = [], lbIdx = 0;

  function lbBuild() {
    if (lb) return lb;
    lb = document.createElement('div');
    lb.className = 'koral-lb';
    lb.innerHTML =
      '<button class="koral-lb__close" aria-label="Cerrar">&times;</button>' +
      '<button class="koral-lb__nav koral-lb__nav--prev" aria-label="Anterior">&#8249;</button>' +
      '<button class="koral-lb__nav koral-lb__nav--next" aria-label="Siguiente">&#8250;</button>' +
      '<img class="koral-lb__img" alt="">' +
      '<div class="koral-lb__cap"></div>' +
      '<div class="koral-lb__strip"></div>';
    document.body.appendChild(lb);

    lb.querySelector('.koral-lb__close').addEventListener('click', lbClose);
    lb.querySelector('.koral-lb__nav--prev').addEventListener('click', function () { lbGo(-1); });
    lb.querySelector('.koral-lb__nav--next').addEventListener('click', function () { lbGo(1); });
    lb.addEventListener('click', function (e) { if (e.target === lb) lbClose(); });
    document.addEventListener('keydown', function (e) {
      if (!lb || lb.style.display !== 'flex') return;
      if (e.key === 'Escape') lbClose();
      if (e.key === 'ArrowLeft') lbGo(-1);
      if (e.key === 'ArrowRight') lbGo(1);
    });
    var x0 = null;
    lb.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    lb.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 45) lbGo(dx < 0 ? 1 : -1);
      x0 = null;
    }, { passive: true });
    return lb;
  }

  function lbRender() {
    lb.querySelector('.koral-lb__img').src = sized(lbImgs[lbIdx], 1400);
    var strip = lb.querySelector('.koral-lb__strip');
    Array.prototype.forEach.call(strip.children, function (b, i) {
      if (i === lbIdx) { b.classList.add('is-on'); b.style.opacity = '1'; b.style.borderColor = '#fff'; }
      else { b.classList.remove('is-on'); b.style.opacity = '.55'; b.style.borderColor = 'transparent'; }
    });
    var multiple = lbImgs.length > 1;
    lb.querySelector('.koral-lb__nav--prev').style.display = multiple ? 'flex' : 'none';
    lb.querySelector('.koral-lb__nav--next').style.display = multiple ? 'flex' : 'none';
    strip.style.display = multiple ? 'flex' : 'none';
  }

  function lbGo(d) {
    lbIdx = (lbIdx + d + lbImgs.length) % lbImgs.length;
    lbRender();
  }

  function lbOpen(images, index, titulo) {
    lbBuild();
    lbImgs = images;
    lbIdx = index < 0 ? 0 : index;
    var strip = lb.querySelector('.koral-lb__strip');
    strip.innerHTML = '';
    images.forEach(function (src, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'koral-lb__t';
      b.setAttribute('aria-label', 'Foto ' + (i + 1));
      var im = document.createElement('img');
      im.src = sized(src, 140);
      im.alt = '';
      b.appendChild(im);
      b.addEventListener('click', function () { lbIdx = i; lbRender(); });
      strip.appendChild(b);
    });
    lb.querySelector('.koral-lb__cap').textContent = titulo || '';
    lbRender();
    document.body.classList.add('koral-lb-open');
    document.body.style.overflow = 'hidden';
    lb.classList.add('is-open');
    // Estilo en linea: no depende de transiciones ni observadores (ver nota 4).
    lb.style.display = 'flex';
    lb.style.opacity = '1';
  }

  function lbClose() {
    if (!lb) return;
    lb.classList.remove('is-open');
    lb.style.display = 'none';
    lb.style.opacity = '0';
    document.body.classList.remove('koral-lb-open');
    document.body.style.overflow = '';
  }

  function esUnitalla(p) {
    if (!p || !p.variants || p.variants.length !== 1) return false;
    var t = (p.variants[0].title || '').toLowerCase();
    return t.indexOf('unitalla') > -1 || t.indexOf('talla unica') > -1 || t.indexOf('talla única') > -1;
  }

  function build(card, media, p) {
    if (media.dataset.koralBuilt) return;
    media.dataset.koralBuilt = '1';

    var ancla = card.querySelector('.card__inner') || media.closest('.card__media') || media;
    var images = (p.images || []).map(function (u) {
      return u.indexOf('//') === 0 ? 'https:' + u : u;
    });

    if (esUnitalla(p) && !ancla.querySelector('.koral-badge')) {
      var badge = document.createElement('span');
      badge.className = 'koral-badge';
      badge.textContent = 'Talla única';
      ancla.appendChild(badge);
    }

    if (!images.length) return;

    var principalEsVideo = !!media.querySelector('video');
    var extra = principalEsVideo ? images.slice(0, MAX) : images.slice(1, 1 + MAX);
    if (!extra.length) return;

    var swap = document.createElement('img');
    swap.className = 'koral-swap';
    swap.alt = '';
    media.appendChild(swap);

    var strip = document.createElement('div');
    strip.className = 'koral-thumbs';

    extra.forEach(function (src) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'koral-thumb';
      b.setAttribute('aria-label', 'Ampliar foto del vestido');
      var im = document.createElement('img');
      im.src = sized(src, 140);
      im.alt = '';
      im.loading = 'lazy';
      b.appendChild(im);

      b.addEventListener('mouseenter', function () {
        swap.src = sized(src, 900);
        swap.classList.add('is-on');
        swap.style.opacity = '1';
        Array.prototype.forEach.call(strip.querySelectorAll('.koral-thumb'), function (x) {
          x.classList.remove('is-on');
        });
        b.classList.add('is-on');
      });

      b.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        lbOpen(images, images.indexOf(src), p.title || '');
      });

      strip.appendChild(b);
    });

    var host = media.closest('.card-wrapper') || card;
    host.addEventListener('mouseleave', function () {
      swap.classList.remove('is-on');
      swap.style.opacity = '0';
      Array.prototype.forEach.call(strip.querySelectorAll('.koral-thumb'), function (x) {
        x.classList.remove('is-on');
      });
    });

    ancla.appendChild(strip);
  }

  function load(card) {
    if (card.dataset.koralThumbs) return;
    card.dataset.koralThumbs = '1';
    if (card.closest && card.closest('.koral-no-thumbs')) return;

    var media = card.querySelector('.card__media .media') || card.querySelector('.card__media');
    var link = card.querySelector('a[href*="/products/"]');
    if (!media || !link || media.dataset.koralBuilt) return;

    var url = link.getAttribute('href').split('?')[0].split('#')[0];
    if (cache[url]) { build(card, media, cache[url]); return; }

    fetch(url + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) { if (p) { cache[url] = p; build(card, media, p); } })
      .catch(function () {});
  }

  var io = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting) { load(e.target); io.unobserve(e.target); }
        });
      }, { rootMargin: '300px 0px' })
    : null;

  function init() {
    css();
    var lista = document.querySelectorAll('.card-wrapper');
    if (!lista.length) lista = document.querySelectorAll('.card');
    Array.prototype.forEach.call(lista, function (c) {
      if (c.dataset.koralThumbs || c.dataset.koralSeen) return;
      if (!c.querySelector('.card__media')) return;
      c.dataset.koralSeen = '1';
      if (io) io.observe(c); else load(c);
      setTimeout(function () { if (!c.dataset.koralThumbs) load(c); }, 1500);
    });
  }

  if ('MutationObserver' in window) {
    new MutationObserver(init).observe(document.documentElement, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  window.addEventListener('load', init);
  setTimeout(init, 2500);
  document.addEventListener('shopify:section:load', init);
})();
